import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p399320508330459136',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
